<template>
  <div class="w-full flex flex-col gap-24">
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[56px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
    <div class="animate-pulse bg-grey-divider-subdued rounded h-[300px]" />
  </div>
</template>

<script lang="ts">
export default {
  name: 'SearchLoadingSkeleton',
};
</script>
